const SKIP_TAGS = new Set(["HTML", "BODY", "SCRIPT", "STYLE", "LINK", "META"]);

export function textOf(node: Element, max = 80) {
  const labelled = node.getAttribute("aria-label")
    || node.getAttribute("title")
    || node.getAttribute("data-track")
    || node.getAttribute("alt");
  if (labelled)
    return clip(labelled, max);
  const text = (node.textContent || "").replace(/\s+/g, " ").trim();
  return clip(text, max);
}

export function cssPath(node: Element) {
  const parts: string[] = [];
  let current: Element | null = node;
  while (current && parts.length < 5 && !SKIP_TAGS.has(current.tagName)) {
    const id = current.id ? `#${cssEscape(current.id)}` : "";
    const name = current.getAttribute("name");
    const named = !id && name ? `[name="${cssEscape(name)}"]` : "";
    const nth = siblingIndex(current);
    parts.unshift(`${current.tagName.toLowerCase()}${id}${named}${nth}`);
    current = current.parentElement;
  }
  return parts.join(">");
}

const TRACKABLE = [
  "button",
  "a",
  "[role='button']",
  "[role='tab']",
  "[role='radio']",
  "[role='menuitem']",
  "[data-track]",
  "[aria-pressed]",
  ".model-card",
  ".workspace-nav-item",
  ".canvas-tool",
  ".canvas-render-action",
  ".canvas-render-preset",
  ".object-toolbar-button",
  ".object-toolbar-chip",
  ".workspace-icon-button",
  ".workspace-save-button",
  ".share-button",
].join(", ");

export function closestTrackable(node: EventTarget | null) {
  if (!(node instanceof Element))
    return null;
  const labeled = node.closest(TRACKABLE);
  if (labeled)
    return labeled;
  const withLabel = node.closest("[aria-label]");
  if (withLabel && withLabel.tagName !== "MAIN" && withLabel.tagName !== "DIV")
    return withLabel;
  return null;
}

export function closestCanvas(node: EventTarget | null) {
  if (!(node instanceof Element))
    return null;
  return node.closest("canvas");
}

export function isSensitive(node: Element) {
  if (node instanceof HTMLInputElement) {
    const type = (node.type || "").toLowerCase();
    const name = `${node.name} ${node.id} ${node.autocomplete}`.toLowerCase();
    if (type === "password" || type === "hidden")
      return true;
    if (/pass|pwd|token|secret|code|otp|sms/.test(name) && type !== "search")
      return true;
  }
  return Boolean(node.closest("[data-track-ignore]"));
}

export function clip(value: string, max: number) {
  const next = value.trim();
  if (next.length <= max)
    return next;
  return next.slice(0, max);
}

function siblingIndex(node: Element) {
  const parent = node.parentElement;
  if (!parent)
    return "";
  const same = [...parent.children].filter((child) => child.tagName === node.tagName);
  if (same.length < 2)
    return "";
  return `:nth-of-type(${same.indexOf(node) + 1})`;
}

function cssEscape(value: string) {
  return value.replace(/([^\w-])/g, "\\$1");
}
